import { Values } from 'components/desktop/_general/NutritionFactsLabel/NutritionFactsLabel';

export const nutritionFactsLabelInformations: Array<{
	name: keyof Values;
	id: string[];
	dailyValue: number[];
}> = [
	{
		id: [
			'79993f95-89dc-4733-92a5-d6e5e5ac0d11',
			'b9b7e5a9-f4d5-e911-b838-00505684d210',
			'b9b7e5a9-f4d5-e911-b838-00505684d210',
		],
		name: 'calories',
		dailyValue: [],
	},
	{
		id: [
			'e25e67b1-2e04-4c5b-93fa-9e3f42b0fb1b',
			'bbb7e5a9-f4d5-e911-b838-00505684d210',
			'bbb7e5a9-f4d5-e911-b838-00505684d210',
		],
		name: 'fatTotal',
		dailyValue: [78, 78, 78000],
	},
	{
		id: [
			'554004d1-c8d5-4906-90b3-36b9d617230d',
			'95bd5208-460f-4296-b7e0-667ec6cb7c6d',
			'95bd5208-460f-4296-b7e0-667ec6cb7c6d',
		],
		name: 'fatSaturated',
		dailyValue: [20, 20, 20000],
	},
	{
		id: ['0bf5d94d-ec01-42e8-af25-7b5b1a033eff', 'dcea72b4-b2fa-4fcc-9f52-bebe462a773d'],
		name: 'fatTrans',
		dailyValue: [],
	},
	{
		id: [
			'521a3b99-d852-41cf-bf73-09aa32fc0433',
			'dff508a7-c0eb-4759-b7ea-052fcb7cfe1e',
			'dff508a7-c0eb-4759-b7ea-052fcb7cfe1e',
		],
		name: 'cholesterol',
		dailyValue: [300, 300, 300],
	},
	{
		id: [
			'991616fb-7efa-4b40-b1d3-c8af66f49dac',
			'1ca576ef-cfe7-4812-949e-e1508f7d8844',
			'1ca576ef-cfe7-4812-949e-e1508f7d8844',
		],
		name: 'sodium',
		dailyValue: [2300, 2300, 2300],
	},
	{
		id: [
			'a6b5d693-e129-4ff3-8b50-c1865abb6886',
			'bab7e5a9-f4d5-e911-b838-00505684d210',
			'bab7e5a9-f4d5-e911-b838-00505684d210',
		],
		name: 'carbohydrateTotal',
		dailyValue: [275, 275, 275000],
	},
	{
		id: [
			'd9086fcb-2ecd-4807-845d-dee9dabefc9d',
			'd52af111-a601-4be6-ac84-16935dfd5d2b',
			'd52af111-a601-4be6-ac84-16935dfd5d2b',
		],
		name: 'fiberDietary',
		dailyValue: [28, 28, 28000],
	},
	{
		id: [
			'add88770-6096-4ef0-aca8-c12887ff4289',
			'c2b7b49d-fe1d-4058-9e83-372021f3d5b7',
			'c2b7b49d-fe1d-4058-9e83-372021f3d5b7',
		],
		name: 'sugarsTotal',
		dailyValue: [],
	},
	{
		id: [
			'1b240b3e-ec56-4002-bead-a102476f71c3',
			'bcb7e5a9-f4d5-e911-b838-00505684d210',
			'bcb7e5a9-f4d5-e911-b838-00505684d210',
		],
		name: 'protein',
		dailyValue: [50, 50, 50000],
	},
	{
		id: [
			'66d86085-431f-49d8-afe5-ceb352dad44f',
			'ac967acb-4778-453c-b132-bde1b70eac28',
			'ac967acb-4778-453c-b132-bde1b70eac28',
		],
		name: 'vitaminD',
		dailyValue: [20, 20, 20],
	},
	{
		id: [
			'76b86c0c-fc0b-49e9-b589-4b4411138acb',
			'c8946d95-8bf8-42b8-aa80-2040b91bf069',
			'c8946d95-8bf8-42b8-aa80-2040b91bf069',
		],
		name: 'calcium',
		dailyValue: [1300, 1300, 1300],
	},
	{
		id: [
			'9f454137-9114-4076-b852-bfe822dc8058',
			'6b27c04b-9dd4-4900-9f05-57b39d733bad',
			'6b27c04b-9dd4-4900-9f05-57b39d733bad',
		],
		name: 'iron',
		dailyValue: [18, 18, 18000],
	},
	{
		id: [
			'94a5feac-805b-4526-b5ce-ec82ba435789',
			'772162b9-605d-4828-878f-d3eb0f920e57',
			'772162b9-605d-4828-878f-d3eb0f920e57',
		],
		name: 'potassium',
		dailyValue: [4700, 4700, 4700],
	},
];
